import { Injectable } from '@angular/core';
import { RulesRepository } from '@core/repositories/rules.repository';
import { Rule } from '@shared/interfaces/rule';
import { Observable, of, throwError } from 'rxjs';

interface ResultRule {
  id: number;
  attributes: {
    name: string;
  };
}

@Injectable({ providedIn: 'root' })
export class FakeRulesRepository implements RulesRepository {
  url: string;

  dataRules: Array<ResultRule> = [
    {
      id: 301,
      attributes: {
        name: 'Regla 3'
      }
    },
    {
      id: 401,
      attributes: {
        name: 'Regla 4'
      }
    },
    {
      id: 501,
      attributes: {
        name: 'Regla 5'
      }
    }
  ];

  rules = {
    data: this.dataRules
  };

  getItems(): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(this.rules);
  }

  add(rule: Rule): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  edit(rule: Rule): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }

  delete(item: any): Observable<any> {
    // return throwError({ status: 500, detail: 'Error' });

    return of(true);
  }
}
